<template>
    <div>
        <img src="@/assets/customerService/img1.png" alt="">
        <img src="@/assets/customerService/img2.png" alt="">
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
img {
    width: 100%;
}
</style>